<ng-container *ngIf="scope">
  <app-embedded-toolbar (onConfigure)="scope.openConfiguration()" [configurationName]="scope.translations.FOOTER_CONFIG"></app-embedded-toolbar>
  <footer class="cfo" [style.--footer-background]="scope.config.footerBackgroundColor || null" [style.--footer-text]="scope.config.footerTextColor || null" [style.--footer-link]="scope.config.footerLinkColor || null">

    <!-- Dynamic nav links column -->
    <div class="cfo__links" disabledDiv>
      <h5 class="cfo__links-heading">{{ scope.getText | transform:'QUICK_LINKS' }}</h5>
      <ng-container *ngIf="(scope.userChanged$ | async) else unauthenticated">
        <ng-container *ngTemplateOutlet="authenticated"></ng-container>
      </ng-container>
    </div>

    <!-- Bottom bar -->
    <div class="cfo__bottom">
      <div class="cfo__legal">
        <ng-container *ngIf="scope.cookiesText as cookiesText">{{ cookiesText }}</ng-container>
        <br>
        <span class="cfo__copyright">{{ scope.copyrightText || '© Kleos, Inc. ' + scope.year + ', All rights reserved.' }}</span>
      </div>
    </div>
  </footer>

  <ng-template #unauthenticated>
    <ng-container *ngFor="let route of scope.unauthenticatedRoutes">
      <a class="cfo__link" *ngIf="!route.externalLink"
         [routerLink]="route.link"
         [routerLinkActive]="['cfo__link--active']"
         [routerLinkActiveOptions]="route.routerLinkActiveOptions || {}"
         [innerText]="scope.getText | transform:route.textMapKey"></a>
      <a class="cfo__link" *ngIf="route.externalLink"
         [href]="route.externalLink"
         [innerText]="scope.getText | transform:route.textMapKey"></a>
    </ng-container>
  </ng-template>

  <ng-template #authenticated>
    <ng-container *ngFor="let route of scope.authenticatedRoutes">
      <a class="cfo__link" *ngIf="!route.externalLink"
         [class.disabled_div]="route.link === '/logout' && (scope.isPreviewMode$ | async)"
         [routerLink]="route.link"
         [routerLinkActive]="['cfo__link--active']"
         [routerLinkActiveOptions]="route.routerLinkActiveOptions || {}"
         [innerText]="scope.getText | transform:route.textMapKey"></a>
      <a class="cfo__link" *ngIf="route.externalLink"
         [href]="route.externalLink"
         [innerText]="scope.getText | transform:route.textMapKey"></a>
    </ng-container>
  </ng-template>

</ng-container>
